"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoProvider = void 0;
const encoding_1 = require("./encoding");
class CryptoProvider {
    /** Generates a random UUID v4 */
    async uuid() {
        const bytes = await this.randomBytes(16);
        // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
        bytes[6] = (bytes[6] & 0x0f) | 0x40;
        bytes[8] = (bytes[8] & 0x3f) | 0x80;
        // Canonical representation
        // XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
        return [
            (0, encoding_1.bytesToHex)(bytes.slice(0, 4)),
            "-",
            (0, encoding_1.bytesToHex)(bytes.slice(4, 6)),
            "-",
            (0, encoding_1.bytesToHex)(bytes.slice(6, 8)),
            "-",
            (0, encoding_1.bytesToHex)(bytes.slice(8, 10)),
            "-",
            (0, encoding_1.bytesToHex)(bytes.slice(10, 16)),
        ].join("");
    }
    async randomHex(n) {
        return (0, encoding_1.bytesToHex)(await this.randomBytes(n));
    }
    async randomBase32(n) {
        return (0, encoding_1.bytesToBase32)(await this.randomBytes(n));
    }
}
exports.CryptoProvider = CryptoProvider;
//# sourceMappingURL=crypto.js.map